module.exports = __webpack_public_path__ + "university-mcgill.png?e4ac4ca7e6a9880687ef69d680eae5e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/university-mcgill.png
// module id = 148
// module chunks = 0